// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.OrgWordingForeword{
    padding: 30px;
   
}


.OrdWordCTA{
    /* background-color: red; */
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
}
.OrdWordCTA button{
    padding: 15px 24px;
    background-color: #003300;
    border: none;
    border-radius: 3px;
    color: white;
    cursor: pointer;
}
.OrdWordCTA button:hover{
    /* padding: 12px 24px; */
    background-color: black;
   
}`, "",{"version":3,"sources":["webpack://./src/Components/OrgWording/OrgWording.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;;AAEjB;;;AAGA;IACI,2BAA2B;IAC3B,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,uBAAuB;;AAE3B","sourcesContent":["\n\n.OrgWordingForeword{\n    padding: 30px;\n   \n}\n\n\n.OrdWordCTA{\n    /* background-color: red; */\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 30px;\n}\n.OrdWordCTA button{\n    padding: 15px 24px;\n    background-color: #003300;\n    border: none;\n    border-radius: 3px;\n    color: white;\n    cursor: pointer;\n}\n.OrdWordCTA button:hover{\n    /* padding: 12px 24px; */\n    background-color: black;\n   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
